import { API_URL, ID_TOKEN_KEY, TOKEN_PREFIX } from "@/common/config"
import { ApiService, request } from "@dg/request"
import { getWithExpiry } from "@dg/utils"
import { Notify } from "@/components/Base"
import { toLogin } from "./basic"

/* 给 ApiService 扩展 patch 方法 */
class NewService extends ApiService {
  patch(resource, params, options = {}) {
    this.onBeforeRequest(options)
    return this.request.patch(`${resource}`, { data: params, ...options })
  }
}
const apiService = new NewService(request)

const Message = (error, fnc) => {
  Notify.error({ message: error, onClose: fnc })
}

apiService.extend({
  prefix: API_URL,
  timeout: 200000,
  errorHandler: async function (error) {
    const { data, request } = error
    if (data) {
      const { status, code = status, error: errMsg, message = errMsg } = data
      // 超时
      if (error.type === "Timeout") Message("请求超时,请重试")
      // 重登
      else if (code === 401) {
        Message("您还未登录或登录过期，请先登录再进行操作", toLogin)
        throw data
      } else {
        const { useError = true } = request.options
        if (useError) {
          const msg = message || (code ? `${code}：系统错误` : "系统错误")
          Message(msg)
        }
      }
    } else {
      Message("系统错误")
    }
    return { success: false, data }
  }
})

apiService.request.use(async (ctx, next) => {
  const { headers } = ctx.req.options
  let token = getWithExpiry(ID_TOKEN_KEY)
  if (token && !token.isExpired) {
    ctx.req.options.headers = {
      Authorization: `${TOKEN_PREFIX} ${token.value}`,
      ...headers
    }
  }

  await next()
})

// 请求数据处理
apiService.request.use(async (ctx, next) => {
  await next()
  const { res } = ctx
  const { code } = res // 假设返回结果为 : { success: false, errorCode: 'B001' }
  if (code >= 200 && code < 300) {
    ctx.res = { success: true, ...res }
  }
})

export default apiService
